// extracted by mini-css-extract-plugin
export var createdDate = "_hi-1";
export var divider = "_hi-2";
export var headerDivider = "_hi-3";
export var messagesCard = "_hi-0";
export var messagesContainer = "_hi-7";
export var messagesContainerWrapper = "_hi-4";
export var pointerCapturingButtonBoxes = "_hi-a";
export var showLeftPanelButton = "_hi-9";
export var showMoreButton = "_hi-c";
export var showMoreButtonContainer = "_hi-b";
export var summaryTitle = "_hi-6";
export var systemMessageCardWrapper = "_hi-d";
export var topButtons = "_hi-8";
export var withPadding = "_hi-5";